import { configureStore } from "@reduxjs/toolkit";
import { AuthReducer } from "./auth/authSlice";
import { BlogReducer } from "./blog/blogSlice";

const store = configureStore({
    reducer: {
        auth: AuthReducer,
        blog: BlogReducer
    }
});

export default store;